import React, { Component } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import {
  createBrowserRouter,
  RouterProvider,
  BrowserRouter,
  Route,
  Router,
} from "react-router-dom";
import Welcome from "./views/Welcome";
// import './Fonts/Klavika/klavika-bold-italic.ttf';
// import './Fonts/Klavika/klavika-bold.ttf';
// import './Fonts/Klavika/klavika-light-italic.ttf';
// import './Fonts/Klavika/klavika-light.ttf';
// import './Fonts/Klavika/klavika-medium-italic.ttf';
// import './Fonts/Klavika/klavika-medium.ttf';
// import './Fonts/Klavika/klavika-regular-italic.ttf';
// import './Fonts/Klavika/klavika-regular.ttf';

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
